const APICalendarRequest = {};

APICalendarRequest["getAllActivitiesBySiteId"] = async (accessToken, id, lowerDate, upperDate) => {
	try {
		const response = await fetch('/api/activities/site/'+ id + '/' + lowerDate +'/' + upperDate, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APICalendarRequest["getAllActivityTypes"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/activity-type', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APICalendarRequest["getActivityTypeById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/activity-type/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APICalendarRequest["getActivityById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/activities/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APICalendarRequest["getAllParticipantTypes"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/participant-type', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}


APICalendarRequest["getParticipantTypeById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/participant-type/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APICalendarRequest["getAllTrainingModules"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/training-module', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APICalendarRequest["getAllTrainingModulesByTypeId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/training-module/participant-type/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

// POST Requests

APICalendarRequest["addActivity"] = async (accessToken, data) => {
	try {
		const response = await fetch('/api/activities', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APICalendarRequest["addTrainingModule"] = async (accessToken, data) => {
	try {
		const response = await fetch('/api/lib/training-module', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

// PATCH Requests

APICalendarRequest["editActivity"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/activities/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APICalendarRequest["editTrainingModule"] = async (accessToken, data) => {
	try {
		const response = await fetch('/api/lib/training-module', {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

export default APICalendarRequest
